// Copyright (C) 2020 GanttProject Cloud OU
// Author: Dmitry Barashev (dbarashev@ganttproject.cloud)
//
// This is the entry point to a family of pages nested under /about URL
// The page to show is chosen with the help of client-side router.

import { createApp } from 'vue';
import App from '@/RouterApp.vue';
import { createRouter, createWebHistory } from 'vue-router';
import AboutContacts from '@/components/AboutContacts.vue';
import AboutPricing from '@/components/AboutPricing.vue';
import AboutPrivacy from '@/components/AboutPrivacy.vue';
import AboutPrivateBeta from '@/components/AboutPrivateBeta.vue';
import AboutTeam from '@/components/AboutTeam.vue';
import AboutTos from '@/components/AboutTos.vue';
import Promo202111 from '@/components/Promo202111.vue';
import { installGoogleAnalytics } from '@/utils/Analytics';
import { registerUiDirectives } from './utils/Ui';

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/about/contacts',
      component: AboutContacts,
    },
    {
      path: '/about/pricing',
      component: AboutPricing,
    },
    {
      path: '/about/privacy',
      component: AboutPrivacy,
    },
    {
      path: '/about/private-beta',
      component: AboutPrivateBeta,
    },
    {
      path: '/about/team',
      component: AboutTeam,
    },
    {
      path: '/about/tos',
      component: AboutTos,
    },
    {
      path: '/about/promo',
      component: Promo202111,
    },
  ],
});

const app = createApp(App);
app.use(router);
registerUiDirectives(app);
app.mount('#app');
installGoogleAnalytics();
